const pad2 = (value: number): string => String(value).padStart(2, '0');

const getFullYear = (yy: number, now: Date): number => {
  const currentYear = now.getUTCFullYear();
  const currentYear2Digit = currentYear % 100;

  return yy <= currentYear2Digit ? 2000 + yy : 1900 + yy;
};

export const decodeZaIdBirthdate = (zaId: string, now = new Date()): string | null => {
  if (!/^\d{13}$/.test(zaId)) {
    return null;
  }

  const yy = Number(zaId.slice(0, 2));
  const month = Number(zaId.slice(2, 4));
  const day = Number(zaId.slice(4, 6));
  const year = getFullYear(yy, now);

  const candidate = new Date(Date.UTC(year, month - 1, day));

  if (
    candidate.getUTCFullYear() !== year ||
    candidate.getUTCMonth() !== month - 1 ||
    candidate.getUTCDate() !== day
  ) {
    return null;
  }

  return `${pad2(day)}.${pad2(month)}.${year}`;
};

export const isBirthdateWithinAgeRange = (birthdate: string, min: number, max: number, now = new Date()): boolean => {
  const [day, month, year] = birthdate.split('.').map(Number);
  if (!day || !month || !year) {
    return false;
  }

  const birth = new Date(Date.UTC(year, month - 1, day));
  if (
    birth.getUTCFullYear() !== year ||
    birth.getUTCMonth() !== month - 1 ||
    birth.getUTCDate() !== day
  ) {
    return false;
  }

  const currentYear = now.getUTCFullYear();
  const currentMonth = now.getUTCMonth();
  const currentDay = now.getUTCDate();

  let age = currentYear - year;
  const hadBirthday = currentMonth > month - 1 || (currentMonth === month - 1 && currentDay >= day);
  if (!hadBirthday) {
    age -= 1;
  }

  return age >= min && age <= max;
};


